import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetTasksRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/GetTasks`,
	params: { userId },
	hasLoading: false
});

export const GetTasksDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/GetTasksDropdowns`
});

export const EditTasksDetailsRequest = BridgeCallDto => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}BridgeCall/EditTasksDetails`,
	data: BridgeCallDto
});

export const ExportBridgesRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/ExportBridges`,
	params: { userId }
});

export const CreateNewBridgeRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/CreateNewBridge`,
	params: { userId }
});

export const UploadStatusFileRequest = (userId, file) => {
	const formData = new FormData();
	formData.append('file', file);
	formData.append('user', userId);
	console.log("form data file", formData.get("file"));
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}BridgeCall/UploadStatusFile`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

export const DownloadTemplateRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/DownloadTemplate`,
	params: { userId }
});

export const CloseBridgeRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/CloseBridge`,
	params: { userId }
});

export const GetBridgeStatusRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/GetBridgeEmail`,
	params: { userId }
});


export const GetLastBridgeSummaryTablesRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/GetLastBridgeSummaryTables`,
	params: { userId }
});


export const GetMOCNTableRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/GetMOCNTable`,
	params: { userId }
});


export const GetProximityTableRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BridgeCall/GetProximityTable`,
	params: { userId }
});

